/**
 * Created by razial on 04.06.2025.
 */

Meta.GetMainLocationsStreak = function () {
    return 3;
};

Meta.GetAvailableLocations = function () {
    const locations = {};

    for (let locationId = 0; true; ++locationId) {
        const bundle = bundles[`location_${locationId}`];

        if (!bundle || bundle.meta.debug) {
            break;
        }

        locations[locationId] = {
            id: locationId,
            slotId: Meta.SLOT_MAIN,
            locationType: "homefix",
            retire: false
        };
    }

    return locations;
};